/**
 * i18n.js
 * Tatalli Cloud — Çok Dilli Destek Yapılandırması
 * Varsayılan dil: İngilizce
 * Kullanıcı tercihi: localStorage "tatalli_dil" anahtarında saklanır
 */

import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationTR  from './Locales/tr.json';
import translationEN  from './Locales/en.json';

const resources = {
  tr: { translation: translationTR },
  en: { translation: translationEN },
};

// Tercih sırası: localStorage tatalli_dil → tarayıcı dili → 'en'
const kayitliDil = localStorage.getItem('tatalli_dil');
if (!kayitliDil) {
  localStorage.setItem('tatalli_dil', 'en');
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng            : kayitliDil || 'en',
    fallbackLng    : 'en',
    keySeparator   : false,
    interpolation  : { escapeValue: false },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'tatalli_dil',
      caches: ['localStorage'],
    },
  });

export default i18n;
